import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-product-brand",
  "use": "icon-product-brand-usage",
  "viewBox": "0 0 1025 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1025 1024\" id=\"icon-product-brand\"><defs><style type=\"text/css\"></style></defs><path d=\"M959.725 0 538.825 0c-17.1 0-33.4 6.8-45.5 18.8L18.825 493.3c-25.1 25.1-25.1 65.8 0 91l420.9 420.9c12.6 12.6 29 18.8 45.5 18.8 16.5 0 32.9-6.3 45.5-18.8l474.5-474.5c12.1-12.1 18.8-28.4 18.8-45.5L1024.025 64.3C1024.025 28.8 995.225 0 959.725 0zM960.025 485.2c0 0.1 0 0.2-0.1 0.2L485.425 959.9c0 0-0.1 0.1-0.1 0.1 0 0-0.1 0-0.1 0-0.1 0-0.1 0-0.1 0 0 0 0 0 0 0 0 0 0 0-0.1-0.1L64.125 539c0 0-0.1-0.1-0.1-0.1 0-0.1 0-0.2 0-0.3 0 0 0 0 0.1-0.1L538.625 64.1c0.1-0.1 0.1-0.1 0.2-0.1l420.9 0c0.1 0 0.1 0 0.1 0 0 0 0 0 0 0 0.1 0 0.2 0.2 0.2 0.2 0 0 0 0 0 0.1L960.025 485.2z\" p-id=\"6020\" /><path d=\"M704.025 192c-70.7 0-128 57.3-128 128s57.3 128 128 128 128-57.3 128-128S774.725 192 704.025 192zM704.025 384c-35.3 0-64-28.7-64-64s28.7-64 64-64 64 28.7 64 64S739.325 384 704.025 384z\" p-id=\"6021\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/product-brand.svg
// module id = JTBo
// module chunks = 219